/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable,} from '@angular/core';
import { Rating } from '../global/rating-popup/rating.model'
import { Observable, tap } from 'rxjs';
import { AppService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class RatingService{
  displayRating = false;
  ratings:any = ['Hated It!', "Didn't Like!","Was Good!","Liked It!",'Loved It!'];
  stars=0;
  comment:any;
  purpose:any;
  easy_to_use:any;
  loading=false;
  ratingQuestionsAnswers: any[]= [];
  isRatingQuestionsAndOptions = false;
  responses: { [key: number]: number } = {}; // Store user responses
  sample_order_id:number | undefined;
  displayThankYou=false;
  answers:any[]=[];
  sample_rating_id: any;
  sampleId: any;
  inLineloading=false;
  constructor(private _as:AppService) { }

  openRatingPopup(purpose:any,sampleId:any){
    this.displayRating = true;
    if(purpose==='sample delivery'){
      this.loading = true;
      this.getRatingsQuestionsAndOptions(purpose)
      this.sample_order_id = sampleId;
      this.isRatingQuestionsAndOptions = false;
    }
    // this.getRatingsQuestionsAndOptions();
  }

  getRatingsQuestionsAndOptions(purpose:any): Observable<any[]> {
    const url = this._as.api_base_url + 'ab/questions-with-answers/?purpose=' + purpose+'&sample_rating='+this.sample_rating_id;    
    return this._as.getRequest(url, true).pipe(
        tap((response: any) => {
            this.comment = response.comment;
            this.responses = response.answers;
            this.ratingQuestionsAnswers = response.question_dict_list.map((element: any) => ({
                ...element,
                answers: element.answers.map((ans: any) => ({
                    ...ans,
                    selected: false
                })),
                response:''
            }));
            this.loading = false;
            this.isRatingQuestionsAndOptions = true;
        })
    );
}
savedsampleRatingstars(){
  this.saveStarsRating(false,)
}
saveStarsRating(isPopup:boolean,purpose?:any,sampleId?:any,){
  this.sampleId = sampleId;
  const url = this._as.api_base_url + 'ab/sample-order-rating-save/';
  
  const data ={
    stars:this.stars,
    sample_order:this.sampleId
  }
  this._as.postRequest(url,data,true).subscribe((res:any)=>{
    this.sample_rating_id = res.rating_id;
    if(isPopup){
    this.openRatingPopup(purpose,sampleId)
  }
  },(err:any)=>{

    console.log("Same tach issu",err)
  })
}
  submitRatingSample(rating: any): Observable<Rating> {
    rating.sample_order = this.sample_order_id;
    rating.smapleratingId = this.sample_rating_id;
  
    const url = this._as.api_base_url + 'ab/rating-samples/';
    return this._as.postRequest(url, rating, true)
      .pipe(
        tap((response:any) => {
          console.log('Rating submitted:', response);
          this.displayThankYou = true;
          setTimeout(() => {
           
            this.displayThankYou = true;
          }, 300);
          setTimeout
         
        })
      );
  
  }


}
